import { useState, useRef, useEffect } from 'react';
import { formatSql } from '../utils';

export const useSqlEditorState = (rawSql, answerId) => {
  const [formattedSql, setFormattedSql] = useState('');
  const currentSqlRef = useRef('');
  const originalSqlRef = useRef('');

  useEffect(() => {
    const formatted = formatSql(rawSql);
    setFormattedSql(formatted);
    currentSqlRef.current = formatted;
    originalSqlRef.current = formatted;
  }, [rawSql, answerId]);

  return { formattedSql, setFormattedSql, currentSqlRef, originalSqlRef };
};
